import * as React from 'react'

import { colors } from '@flowwai-frontend/shared/style-guide'

import { IconPropsType } from '../types'

export const FeaturedPasscodeLockIcon = (
   props: IconPropsType
): React.ReactElement => {
   const {
      height = 52,
      width = 52,
      stroke = colors['gray-600'],
      ...rest
   } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={52}
         height={52}
         fill='none'
         {...rest}
      >
         <g filter='url(#a)'>
            <rect width={48} height={48} x={2} y={1} fill='#fff' rx={10} />
            <rect
               width={47}
               height={47}
               x={2.5}
               y={1.5}
               stroke='#EAECF0'
               rx={9.5}
            />
            <path
               fill={stroke}
               fillRule='evenodd'
               d='M19.162 17h13.677c.527 0 .982 0 1.356.03.395.033.789.104 1.167.297a3 3 0 0 1 1.311 1.311c.193.378.264.772.296 1.167.031.375.031.83.031 1.356V24a1 1 0 1 1-2 0v-2.8c0-.577 0-.949-.024-1.232-.022-.272-.06-.372-.085-.422a1 1 0 0 0-.437-.437c-.05-.025-.15-.063-.422-.085C33.75 19 33.377 19 32.8 19H19.2c-.577 0-.949 0-1.232.024-.272.022-.372.06-.422.085a1 1 0 0 0-.437.437c-.025.05-.063.15-.085.422C17 20.25 17 20.623 17 21.2v3.6c0 .577 0 .949.024 1.232.022.272.06.372.085.422a1 1 0 0 0 .437.437c.05.025.15.063.422.085.283.023.655.024 1.232.024H25a1 1 0 1 1 0 2h-5.838c-.528 0-.982 0-1.357-.03-.395-.033-.789-.104-1.167-.297a3 3 0 0 1-1.311-1.311c-.193-.378-.264-.772-.296-1.167C15 25.82 15 25.365 15 24.838v-3.677c0-.527 0-.982.03-1.356.033-.395.104-.789.297-1.167a3 3 0 0 1 1.311-1.311c.378-.193.772-.264 1.167-.296.375-.031.83-.031 1.357-.031Zm.588 6a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm5 0a1.25 1.25 0 1 1 2.5 0 1.25 1.25 0 0 1-2.5 0Zm-1 5.25a2.75 2.75 0 1 1 5.5 0v.778c.203.024.43.074.658.19a2 2 0 0 1 .874.874c.138.271.182.541.201.77.017.208.017.454.017.706v.864c0 .252 0 .498-.017.706a2.022 2.022 0 0 1-.201.77 2 2 0 0 1-.874.874 2.022 2.022 0 0 1-.77.201c-.208.017-.454.017-.706.017h-3.864c-.252 0-.498 0-.706-.017a2.022 2.022 0 0 1-.77-.201 2 2 0 0 1-.874-.874 2.022 2.022 0 0 1-.201-.77C27 32.93 27 32.684 27 32.432v-.864c0-.252 0-.498.017-.706.019-.229.063-.499.201-.77a2 2 0 0 1 .874-.874c.228-.116.456-.166.658-.19v-.778ZM29.6 31a8.207 8.207 0 0 0-.588.012l-.002.013c-.01.116-.01.279-.01.575v.8a8.207 8.207 0 0 0 .012.589h.013c.116.01.279.011.575.011h3.8a8.207 8.207 0 0 0 .589-.011v-.014c.01-.116.011-.279.011-.575v-.8a8.207 8.207 0 0 0-.011-.589h-.014A8.207 8.207 0 0 0 33.4 31h-3.8Zm2.65-2h-1.5v-.75a.75.75 0 0 1 1.5 0V29Z'
               clipRule='evenodd'
            />
         </g>
         <defs>
            <filter
               id='a'
               width={52}
               height={52}
               x={0}
               y={0}
               colorInterpolationFilters='sRGB'
               filterUnits='userSpaceOnUse'
            >
               <feFlood floodOpacity={0} result='BackgroundImageFix' />
               <feColorMatrix
                  in='SourceAlpha'
                  result='hardAlpha'
                  values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
               />
               <feOffset dy={1} />
               <feGaussianBlur stdDeviation={1} />
               <feColorMatrix values='0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.05 0' />
               <feBlend
                  in2='BackgroundImageFix'
                  result='effect1_dropShadow_8674_29452'
               />
               <feBlend
                  in='SourceGraphic'
                  in2='effect1_dropShadow_8674_29452'
                  result='shape'
               />
            </filter>
         </defs>
      </svg>
   )
}
